import { render, staticRenderFns } from "./ChatsView.vue?vue&type=template&id=2d9dfef4&scoped=true&"
import script from "./ChatsView.vue?vue&type=script&lang=ts&"
export * from "./ChatsView.vue?vue&type=script&lang=ts&"
import style0 from "./ChatsView.vue?vue&type=style&index=0&id=2d9dfef4&prod&scoped=true&lang=css&"
import style1 from "./ChatsView.vue?vue&type=style&index=1&id=2d9dfef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9dfef4",
  null
  
)

export default component.exports